import { OnboardingResponseStatus } from 'clickNgo/configs/service/onboarding'
import { ContactStatus, ContactWorkflowStatus, IContact } from 'clickNgo/entities/contact'
import { updateContact } from 'clickNgo/entities/contact/api'
import { getJSendErrorMessages } from 'clickNgo/helpers/api'

interface IUpdateRoles {
  newPartnerId: string
  contact: IContact
  newHpRoles: string[]
}

export const updateRoles = async ({ newHpRoles, newPartnerId, contact }: IUpdateRoles) => {
  const contactForRoles: IContact = {
    ...contact,
    partnerId: newPartnerId,
    modifiedValues: ['hpRoles'],
    workflowStatus: ContactWorkflowStatus.New,
    status: ContactStatus.Active,
    hpRoles: newHpRoles,
  }

  const response = await updateContact(contactForRoles, { forceRoles: true })

  if (response?.status !== OnboardingResponseStatus.Success) {
    return {
      success: false,
      contact: contactForRoles,
      errors:
        response?.status === OnboardingResponseStatus.Fail
          ? getJSendErrorMessages(response)
          : [response?.message || 'Unknown error'],
    }
  }

  return { success: true, contact: contactForRoles, errors: [], responseData: response.data }
}
